import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./SkillsManagement.css";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { extractDate, subadminAccessChange } from "../../utils/functions";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import SearchBar from "material-ui-search-bar";
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Popover, Box } from "@mui/material";
import PaginationItem from '@mui/material/PaginationItem';

import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination
} from "@material-ui/core";

// icons 
import { HiOutlineBars3BottomLeft } from "react-icons/hi2";
import { RxCross2, RxCrossCircled } from "react-icons/rx";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";

import EyeIcon from "../../assets/images/eye-tick.png";
import UserIcon from "../../assets/images/users-check.png";

// Elements

import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    SearchFilterContainer,
    DashHeading,
    Button,
    DeleteButton,
    ProfileDetailForm,
    SelectedColumnContainer,
} from "./SkillsManagementElement";
import BlockToggle from "../../components/Toglebutton/Togle";
import NoResults from "../../components/NoResult";


const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "65vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        // border: "1px solid rgba(17, 153, 38, 0.20)",

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
        border: "none"
    },
    textMiddle: {
        // padding: "0.4rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF",
        border: "none"
    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));


const SkillsManagement = ({ setUsers, userData }) => {
    const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

    const skillManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Skill Management"
    )?.permissions || {};


    const canView = !!skillManagementPermissions.view;
    const canAdd = !!skillManagementPermissions.add;
    const canEdit = !!skillManagementPermissions.edit;
    const canDelete = !!skillManagementPermissions.delete;
    const canBlockUnblock = !!skillManagementPermissions.blockUnblock;
    const canDownload = !!skillManagementPermissions.download;


    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [filterStatus, setFilterStatus] = useState("all");
    const [isChecked, setIsChecked] = useState(false)




    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1); // Reset to the first page when rows per page change
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Update page and trigger data fetch
    };


    // For Select checkbox
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (tableData.length === 0) {
            setSelectedRows([]);
        }
    }, [tableData]);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedRows(tableData.map((item) => item._id));
        } else {
            setSelectedRows([]);
        }
    };

    const handleSelectRow = (id) => {
        const newSelectedRows = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];
        setSelectedRows(newSelectedRows);
    };

    const handleClearSelection = () => {
        setSelectedRows([]);
    };

    const [anchorEl, setAnchorEl] = useState(null);



    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget); // Open the filter popover
    };

    const handleClose = () => {
        setAnchorEl(null); // Only close the popover without resetting
    };




    const open = Boolean(anchorEl);
    const id = open ? "filter-popover" : undefined;

    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }


    const SearchAccountManagement = myDeb((search) => {
        setSelectedRows([]);
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };


    const handleCheckboxChange = () => {
        setIsChecked(!isChecked)
    }



    // Get user data
    useEffect(() => {
        getSkillListData(page);
    }, [page, rowsPerPage, searchTerm, filterStatus]);

    const getSkillListData = async (currentPage) => {
        setIsLoading(true);
        setTotalDocs(0);

        try {
            const { data } = await axios.post(`/private/getSkillList?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {
                active: String(filterStatus), // Ensure status is a string
            });

            setTableData(data?.data?.docs);
            setTotalDocs(data?.data?.totalDocs);
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };


    // Block unblock functionality
    const blockUnblock = async (id, status, isBlocked) => {
        try {
            const response = await axios.post(`/private/skillBlock/${id}`, {
                isBlocked
            });

            toast.success(response.data.message, {
                position: "top-right",
            });
            handleClearSelection();
            setSelectedRows([]);

            // Refresh the user list after block/unblock
            getSkillListData(page);
        } catch (error) {
            if (error.response?.status === 419) {
                localStorage.clear();
                Cookies.remove('showProfileSidebar');
                toast.error(error.response.data?.message, {
                    position: "top-right",
                });
                navigate('/');
            } else {
                toast.error('Something went wrong', {
                    position: "top-right",
                });
            }
        }
    };

    // Delete user functionality - handles both single and multiple deletions
    const DeleteUser = async (id = null) => {
        const idsToDelete = id ? [id] : selectedRows;

        if (idsToDelete.length === 0) {
            toast.error('No users selected for deletion', {
                position: "top-right",
            });
            return;
        }

        setIsLoading(true);

        try {
            // Using axios.request to support sending data in the body with DELETE method
            const { data } = await axios({
                method: 'delete',
                url: `/private/deleteSkills`,
                data: {
                    ids: idsToDelete,
                },
            });

            setDeleteModal(false);
            toast.success(data?.message);
            handleClearSelection();
            setSelectedRows([]);  // Clear selected rows after deletion
            getSkillListData(page);  // Refresh table after deletion
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                toast.error('Something went wrong', {
                    position: "top-right",
                });
            }
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <DashboardHeading>
                            Skills Management
                        </DashboardHeading>

                        <SearchFilterContainer>
                            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                <SearchBar
                                    style={{
                                        minWidth: "25rem",
                                        height: "38px",
                                        borderRadius: "20px",
                                        backgroundColor: "#F8F9FB",
                                        color: "#212121",
                                        fontStyle: "Italic",
                                        fontWeight: 300,
                                        fontSize: "15px",
                                        fontFamily: "Roboto",
                                    }}
                                    className={"heightfix"}
                                    onChange={(e) => {
                                        SearchAccountManagement(e);
                                    }}
                                    onCancelSearch={cancelSearch}
                                    placeholder="Search by Skill ID, Skill Name..."
                                    inputProps={{ maxLength: 30 }}
                                />
                            </div>
                            <div>
                                <Button
                                    type="button"
                                    style={{ backgroundColor: "#FFFFFF", color: "#667085", border: "1px solid #E0E2E7", fontFamily: "Inter", fontWeight: "500", borderRadius: "8px" }}
                                    onClick={handleFilterClick}
                                >
                                    <div >Sort by <HiOutlineBars3BottomLeft style={{ fontSize: "1.5rem", color: "#000000" }} /></div>
                                </Button>
                            </div>
                        </SearchFilterContainer>

                        {/* Filter Popover */}
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                        >
                            <Box sx={{ p: 1, width: "130px", display: "flex", justifyContent: "space-between" }}>

                                <div style={{ marginTop: "0px" }}>
                                    <div
                                        className={`Short_active ${filterStatus === "active" ? "selected" : ""}`}
                                        onClick={() => {
                                            setFilterStatus("active");
                                            setPage(1);
                                            handleClose();
                                        }}
                                    >
                                        Active
                                    </div>
                                    <div
                                        className={`Short_active ${filterStatus === "inactive" ? "selected" : ""}`}

                                        onClick={() => {
                                            setFilterStatus("inactive");
                                            setPage(1);
                                            handleClose();
                                        }}
                                    >
                                        Inactive
                                    </div>
                                </div>
                                <div
                                    className="Rest-Button"
                                    onClick={() => {
                                        setFilterStatus("all"); // reset filter
                                        handleClose();
                                    }}
                                >
                                    Reset
                                </div>
                            </Box>
                        </Popover>


                        {selectedRows.length > 0 && (
                            <SelectedColumnContainer>
                                <DeleteButton
                                    type="button"
                                    className="buttonWidthResponsive"
                                    onClick={() => {
                                        setDeleteModal(true);
                                    }}
                                >
                                    Delete
                                </DeleteButton>
                                <div className="column-selected">{selectedRows.length} Selected</div>
                                <div
                                    className="container-clear-selection"
                                    onClick={handleClearSelection}
                                >
                                    <RxCrossCircled />
                                    <span className="column-selected">Clear Response</span>
                                </div>
                            </SelectedColumnContainer>
                        )}

                        <TableContainer
                            className={classes.tableMainContainer}
                        >
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow} >
                                        {!(!canDelete && adminData?.userType === "subAdmin") && (
                                            <TableCell className={classes.tableHeadingCell}>
                                                <div style={{ marginLeft: "1rem", display: "flex", gap: "1rem" }}>
                                                    <Checkbox
                                                        style={{ padding: "2px" }}
                                                        className={classes.tableCheckbox}
                                                        indeterminate={selectedRows.length > 0 && selectedRows.length < tableData.length}
                                                        // checked={selectedRows.length > 0 && selectedRows.length === tableData.length}
                                                        checked={tableData.length > 0 && tableData.every((item) => selectedRows.includes(item._id))}
                                                        onChange={handleSelectAll}
                                                        color="primary"
                                                    // disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                                    />
                                                    <div > S.No</div>
                                                </div>
                                            </TableCell>
                                        )}
                                        {/* <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell> */}
                                        {!(!canBlockUnblock && adminData?.userType === "subAdmin") && (
                                            <TableCell className={classes.tableHeadingCell}>
                                                Action
                                            </TableCell>
                                        )}
                                        <TableCell className={classes.tableHeadingCell}>
                                            Created On
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Skill ID
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Skill Name
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Associated Gigs
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Creator Name
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {tableData && tableData.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {/* {tableData.map((user, index) => ( */}
                                            {tableData
                                                .filter((user) => {
                                                    if (filterStatus == true) return user.isBlocked;
                                                    if (filterStatus == false) return !user.isBlocked;
                                                    return true; // Show all
                                                })
                                                .map((user, index) => (
                                                    <TableRow className={classes.tableBodyRow} key={user._id}>
                                                        {!(!canDelete && adminData?.userType === "subAdmin") && (
                                                            <TableCell className={classes.textMiddle}>
                                                                <div style={{ marginLeft: "1rem", display: "flex", gap: "1rem" }}>
                                                                    <Checkbox
                                                                        style={{ padding: "2px" }}
                                                                        checked={selectedRows.includes(user._id)}
                                                                        onChange={() => handleSelectRow(user._id)}
                                                                        color="primary"
                                                                    // disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                                                    />
                                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                        {index + 1 + rowsPerPage * (page - 1)}</div>
                                                                </div>
                                                            </TableCell>
                                                        )}
                                                        {/* <TableCell className={classes.textMiddle}>
                                                            <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                        </TableCell> */}
                                                        {!(!canBlockUnblock && adminData?.userType === "subAdmin") && (
                                                            <TableCell className={classes.textMiddle}>
                                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                    <BlockToggle
                                                                        checked={!user.isBlocked}
                                                                        onChange={() => blockUnblock(user._id, !user.isBlocked)}
                                                                    />
                                                                </div>
                                                            </TableCell>
                                                        )}
                                                        <TableCell className={classes.textMiddle}>
                                                            <div>{extractDate(get(user, "createdAt", "---"))}</div>
                                                        </TableCell>
                                                        <TableCell className={classes.textMiddle}>
                                                            <div>{get(user, "skillId", "---")}</div>
                                                        </TableCell>
                                                        <TableCell className={classes.textMiddle}>
                                                            <div style={{ textTransform: "capitalize", color: "#484848", fontSize: "14px", fontWeight: "700" }}>
                                                                {get(user, "skillName", "---")}
                                                            </div>
                                                        </TableCell>
                                                        <TableCell className={classes.textMiddle}>
                                                            <div>{get(user, "associatedGigs", "---")}</div>
                                                        </TableCell>
                                                        <TableCell className={classes.textMiddle}>
                                                            <div style={{ textTransform: "capitalize", cursor: "pointer", textDecoration: "underline", color: "#375DFB" }}
                                                            // onClick={() => navigate(`/userDetails/${user._id}`, { state: { from: "userManagement" } })}
                                                            >
                                                                {user?.userData?.fullName || "N/A"}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={13} align="center" style={{ padding: "2rem", border: "none" }}>
                                                    <DashHeading style={{ textAlign: "center", padding: "2rem" }}><NoResults /></DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {(tableData && tableData.length > 0) && (
                            <>
                                <Stack spacing={2} className={classes.paginationContainer}>
                                    <Pagination
                                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                        page={page}
                                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </Stack>
                            </>
                        )}
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>

            {/* Modal for Delete User  */}
            <Modal
                maxWidth="lg"
                width="360px"
                RoundedCorners={true}
                isOpen={deleteModal}
                onClose={() => {
                    setDeleteModal(false);
                }}
                backgroundModal={false}
                backgroundModalContent={false}
                title={
                    <div>
                        <div className="d-flex align-items-center justify-content-end">
                            <RxCross2
                                style={{
                                    cursor: "pointer",
                                }}
                                onClick={() => { setDeleteModal(false); }}
                            />
                        </div>
                        <p className="profile-section-text">Delete Skills</p>
                        <div className="logout-header" style={{ paddingTop: "0px" }}>Are you sure you want to delete this skill? Please confirm.</div>
                    </div>
                }
                content={
                    <>
                        <div className="logout-button-group">
                            <div
                                className="cancel-button"
                                onClick={() => {
                                    setDeleteModal(false);
                                }}
                            >
                                Cancel
                            </div>
                            <div className="logout-button" style={{ background: "#5088FB" }} onClick={() => DeleteUser(null)}>
                                Yes
                            </div>
                        </div>
                    </>
                }
            />
            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SkillsManagement);


